// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__3idT9","mainLanding":"Home_mainLanding__2rHMa","main":"Home_main__UU0fQ","error":"Home_error__4bpb1","errorH1":"Home_errorH1__5sORe"};